import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  d: "M35.019 16.53c.202.045.696.185.875.265.442.13.892.223 1.134.679.072.135.111.281.136.433v.215c-.06.34-.175.605-.454.806-.208.149-.457.209-.696.282l-.887.271c-.455.14-.914.25-1.286.578a2.044 2.044 0 0 0-.46.59c-.127.245-.198.52-.279.785l-.298.974c-.06.195-.111.402-.207.582a1.31 1.31 0 0 1-.096.15 1.098 1.098 0 0 1-.206.21 1.131 1.131 0 0 1-.926.198 1.083 1.083 0 0 1-.704-.48c-.137-.214-.308-.783-.366-1.044-.101-.297-.187-.6-.28-.9.02-.114.173-.183.262-.24 1.306-.845 2.524-1.959 3.59-3.113.247-.269.483-.552.717-.833.112-.134.218-.29.345-.407a.214.214 0 0 0 .065.001c.007 0 .014-.002.02-.003Z"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#b)",
  d: "M35.019 16.53c.202.045.696.185.875.265.025.026.027.033.063.043.004.044-.117.178-.147.218-1.324 1.723-3.022 3.31-4.76 4.56-.094.07-.613.44-.677.455-.01.002-.02.001-.029.002l-.018-.051-.027.002c-.101-.297-.187-.6-.28-.9.02-.114.173-.183.262-.24 1.306-.845 2.524-1.959 3.59-3.113.247-.269.483-.552.717-.833.112-.134.218-.29.345-.407a.214.214 0 0 0 .065.001c.007 0 .014-.002.02-.003Z"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#c)",
  d: "M30.277 14.075c.165-.538.264-1.194.787-1.478.28-.152.628-.172.925-.07.269.093.497.285.624.552.123.256.192.555.276.828.11.36.23.721.331 1.085.192.567.512 1.003 1.038 1.265.246.123.51.17.76.272-.006.001-.013.003-.02.003a.214.214 0 0 1-.065 0c-.127.117-.233.272-.345.406-.234.281-.47.564-.718.833-1.065 1.154-2.283 2.268-3.59 3.113-.088.057-.241.126-.26.24a2.758 2.758 0 0 0-.189-.488c-.382-.73-.952-.914-1.663-1.131-.347-.095-1.35-.376-1.612-.544l-.022-.015a.585.585 0 0 1-.063-.046l-.02-.016-.02-.017a.806.806 0 0 1-.095-.092 1.18 1.18 0 0 1-.138-.193l-.013-.023a1.339 1.339 0 0 1-.065-.147 1.076 1.076 0 0 1-.024-.076l-.007-.026a1.188 1.188 0 0 1 .156-.931 1.073 1.073 0 0 1 .35-.325c.286-.167.688-.249 1.005-.346.316-.097.633-.207.953-.288.148-.084.33-.115.484-.2.827-.454.984-1.293 1.24-2.145Z"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#d)",
  d: "M30.277 14.075c.13.02.224.045.34.115a.626.626 0 0 1 .097.501c-.1.543-.61 1.064-1.034 1.353a1.693 1.693 0 0 1-.588.266c-.089.019-.18.026-.267.05-.078.022-.184.078-.261.076l-.01-.017c.147-.082.33-.114.483-.199.827-.454.984-1.293 1.24-2.145Z"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#e)",
  d: "M28.168 19.505c.11-.081.375.139.516.11.18-.036.517-.25.686-.347a12.837 12.837 0 0 0 .936-.603 12.014 12.014 0 0 0 1.092-.872 12.322 12.322 0 0 0 .994-.994 13.423 13.423 0 0 0 .367-.429c.201-.243.416-.5.585-.77.012-.018.049-.07.051-.089 0-.005-.177-.41-.195-.495l.02-.024c.192.567.512 1.003 1.038 1.265.246.123.51.17.76.272-.006.001-.013.003-.02.003a.214.214 0 0 1-.065 0c-.127.117-.233.272-.345.406-.234.281-.47.564-.718.833-1.065 1.154-2.283 2.268-3.59 3.113-.088.057-.241.126-.26.24a2.758 2.758 0 0 0-.189-.488c-.382-.73-.952-.914-1.663-1.131Z"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#f)",
  d: "M3.833 12.078c.021-.184.027-.37.045-.556.051-.528.13-1.105.3-1.604.01.146-.15.729-.183.936h.02c.14.008.28.04.42.06.305.043.61.085.915.136.337.055.677.09 1.014.144l.964.15c.193.031.386.073.58.095.02.002.045.011.06-.003l-.014-.013.019.001c.02-.127.044-.462.13-.543-.26 1.218-.184 2.554.424 3.64.383.682.942 1.215 1.55 1.646.11.078.432.262.501.34.71.4 1.422.761 2.167 1.078.755.32 1.523.596 2.283.903 2.32.938 4.83 2.154 6.218 4.524.199.338.576 1.078.654 1.462l.002.015c.095.243.157.511.214.768a11.033 11.033 0 0 1 .163.98 10.343 10.343 0 0 1 .068 1.494 10.362 10.362 0 0 1-.142 1.486c-.036.21-.073.438-.138.64-.005-.025-.01-.042-.008-.067.01-.137.063-.298.09-.435.068-.347.168-.92.16-1.269 0-.04 0-.068-.027-.098-.176-.02-.372.007-.549.016a31.04 31.04 0 0 1-.819.027c-.208.004-.418-.004-.627.001-.238.006-.475.03-.714.032-.434.005-.881-.011-1.313.042-.064.14-.038.909-.17 1.076l-.014.016c.223-1.059.174-1.966-.106-2.999-.057-.113-.095-.247-.145-.366a4.27 4.27 0 0 0-.365-.68 4.13 4.13 0 0 0-.147-.207c-1.294-1.707-3.808-2.526-5.666-3.242a28.513 28.513 0 0 1-2.286-.986c-.322-.158-.65-.32-.957-.512-.132-.054-.269-.151-.392-.228a10.84 10.84 0 0 1-1.085-.759c-.116-.092-.23-.186-.344-.283a7.746 7.746 0 0 1-2.602-4.628c-.08-.47-.097-.935-.148-1.407v-.823Z"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#g)",
  d: "M21.901 24.49c.096.242.158.51.215.767a11.033 11.033 0 0 1 .163.98 10.343 10.343 0 0 1 .068 1.494 10.362 10.362 0 0 1-.142 1.486c-.036.21-.073.438-.138.64-.005-.025-.01-.042-.008-.067.01-.137.063-.298.09-.435.068-.347.168-.92.16-1.269 0-.04 0-.068-.027-.098-.176-.02-.372.007-.549.016a31.04 31.04 0 0 1-.819.027c-.208.004-.418-.004-.627.001-.238.006-.475.03-.714.032-.434.005-.881-.011-1.313.042-.064.14-.038.909-.17 1.076l-.014.016c.223-1.059.174-1.966-.106-2.999.133.122.231.928.252 1.148.01.105-.006.228.024.327.05.03 3.657-.307 4.073-.346.032-.117-.005-.283-.015-.406-.047-.556-.082-1.078-.206-1.624-.052-.225-.186-.585-.196-.794v-.015Z"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#h)",
  d: "M3.833 12.078c.021-.184.027-.37.045-.556.051-.528.13-1.105.3-1.604.01.146-.15.729-.183.936h.02c.14.008.28.04.42.06.305.043.61.085.915.136.337.055.677.09 1.014.144l.964.15c.193.031.386.073.58.095.02.002.045.011.06-.003l-.014-.013.019.001c.02-.127.044-.462.13-.543-.26 1.218-.184 2.554.424 3.64.383.682.942 1.215 1.55 1.646.11.078.432.262.501.34-.098.02-.629-.39-.736-.472a6.347 6.347 0 0 1-.932-.892c-.182.082-.359.273-.52.401-.42.333-.836.67-1.25 1.01-.184.152-.363.315-.55.463-.098.079-.206.142-.303.222-.12.097-.229.211-.351.305-.111.086-.248.158-.346.26l.004.01.008-.026-.025.045c.03.103.19.247.262.326.733.807 1.582 1.433 2.49 1.977a.658.658 0 0 0 .077.038l.009.017-.011.015c-.132-.054-.269-.151-.392-.228a10.84 10.84 0 0 1-1.085-.759c-.116-.092-.23-.186-.344-.283a7.746 7.746 0 0 1-2.602-4.628c-.08-.47-.097-.935-.148-1.407v-.823Z"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#i)",
  d: "M3.833 3.333h9.483c.208.026.419.03.628.05.339.034.675.086 1.01.153 2.193.446 4.272 1.653 5.674 3.584a9.584 9.584 0 0 1 .326.482 8.287 8.287 0 0 1 .614 1.169 9.188 9.188 0 0 1 .354.975 8.757 8.757 0 0 1 .24 1.016 9.268 9.268 0 0 1 .1.742c.033.359.063.74.026 1.1-.057.547-.29 1.038-.686 1.382a2.09 2.09 0 0 1-1.638.474 1.93 1.93 0 0 1-1.33-.813c-.52-.745-.348-1.537-.536-2.385-.493-2.225-2.348-3.64-4.337-3.944-1.427-.218-2.94.075-4.104 1.044a4.362 4.362 0 0 0-.808.872 4.496 4.496 0 0 0-.353.584 4.733 4.733 0 0 0-.217.491c-.07.189-.12.379-.176.572-.086.081-.11.416-.13.543l-.019-.001.015.013c-.016.014-.041.005-.062.002-.193-.021-.386-.063-.579-.094l-.964-.15c-.337-.054-.677-.089-1.014-.144-.305-.05-.61-.093-.916-.136-.14-.02-.279-.052-.42-.06h-.019c.034-.207.192-.79.183-.936-.17.5-.249 1.076-.3 1.604-.018.185-.024.371-.045.556V3.333Zm0 0v8.745c.021-.184.027-.37.045-.556.051-.528.13-1.105.3-1.604.02-.163.093-.344.147-.5a9.337 9.337 0 0 1 .692-1.551 8.944 8.944 0 0 1 .543-.849 8.906 8.906 0 0 1 6.403-3.64c.177-.018.356-.022.532-.045H3.833Z"
});
var _ref0 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#j)",
  d: "M3.833 12.901c.05.472.067.937.148 1.407a7.746 7.746 0 0 0 2.602 4.628 11.367 11.367 0 0 0 1.43 1.042c.122.077.26.174.391.228.306.192.635.354.957.512a28.737 28.737 0 0 0 2.286.986c1.858.716 4.372 1.535 5.666 3.242a4.13 4.13 0 0 1 .512.887c.05.119.088.253.145.366.28 1.033.33 1.94.106 3l.014-.017c.132-.167.106-.936.17-1.076.432-.053.88-.037 1.313-.042.239-.002.476-.026.714-.032.21-.005.419.003.628-.001.272-.006.546-.014.818-.027.177-.009.373-.035.55-.016.025.03.026.058.027.098.007.349-.093.922-.16 1.269-.028.137-.08.298-.09.435-.002.025.002.042.007.067-.064.355-.195.72-.321 1.054a9.569 9.569 0 0 1-.623 1.32 8.71 8.71 0 0 1-.522.809 9.238 9.238 0 0 1-.495.622 7.403 7.403 0 0 1-.321.349 8.347 8.347 0 0 1-1.65 1.314 9.189 9.189 0 0 1-1.636.792 9.299 9.299 0 0 1-.929.282 8.775 8.775 0 0 1-.95.176c-.31.043-.634.085-.946.076l.003.016H3.833V12.9Zm0 0v14.378c.038-.338.048-.678.098-1.016.192-1.286.68-2.723 1.638-3.554.458-.396.947-.561 1.527-.483.507.068.991.307 1.311.756.282.395.413.935.357 1.433-.065.567-.4 1.06-.577 1.588-.5 1.493-.164 3.307.71 4.548.864 1.23 2.212 1.95 3.599 2.14 1.427.197 2.964-.125 4.113-1.112a4.352 4.352 0 0 0 .946-1.127 4.91 4.91 0 0 0 .305-.614c.084-.21.145-.425.216-.64.223-1.059.174-1.966-.106-2.999-.057-.113-.095-.247-.145-.366a4.27 4.27 0 0 0-.365-.68 4.13 4.13 0 0 0-.147-.207c-1.294-1.707-3.808-2.526-5.666-3.242a28.513 28.513 0 0 1-2.286-.986c-.322-.158-.65-.32-.957-.512-.132-.054-.269-.151-.392-.228a10.84 10.84 0 0 1-1.085-.759c-.116-.092-.23-.186-.344-.283a7.746 7.746 0 0 1-2.602-4.628c-.08-.47-.097-.935-.148-1.407Zm0 15.152v8.614h9.057l-.003-.015c-.346.02-.725-.042-1.068-.09a9.412 9.412 0 0 1-3.95-1.477 9.684 9.684 0 0 1-.975-.723 8.738 8.738 0 0 1-2.889-4.91c-.098-.49-.117-.909-.172-1.399Zm9.054 8.599.003.015h.787l-.003-.016a4.88 4.88 0 0 0-.787 0Z"
});
var _ref1 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#k)",
  d: "M12.887 36.652a4.88 4.88 0 0 1 .787 0l.003.015h-.787l-.003-.015Z"
});
var _ref10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 28.131,
  x2: 36.229,
  y1: 14.26,
  y2: 23.113,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.178,
  stopColor: "#A87CFB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.478,
  stopColor: "#149197"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.793,
  stopColor: "#13A038"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 28.131,
  x2: 36.229,
  y1: 14.26,
  y2: 23.113,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.178,
  stopColor: "#A87CFB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.478,
  stopColor: "#149197"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.793,
  stopColor: "#13A038"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: 28.131,
  x2: 36.229,
  y1: 14.26,
  y2: 23.113,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.178,
  stopColor: "#A87CFB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.478,
  stopColor: "#149197"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.793,
  stopColor: "#13A038"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "d",
  x1: 28.131,
  x2: 36.229,
  y1: 14.26,
  y2: 23.113,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.178,
  stopColor: "#A87CFB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.478,
  stopColor: "#149197"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.793,
  stopColor: "#13A038"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "e",
  x1: 28.131,
  x2: 36.229,
  y1: 14.26,
  y2: 23.113,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.178,
  stopColor: "#A87CFB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.478,
  stopColor: "#149197"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.793,
  stopColor: "#13A038"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "f",
  x1: 13.09,
  x2: 13.09,
  y1: 3.333,
  y2: 32.855,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.313,
  stopColor: "#A87CFB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.585,
  stopColor: "#149197"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.777,
  stopColor: "#13A038"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "g",
  x1: 13.09,
  x2: 13.09,
  y1: 3.333,
  y2: 32.855,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.313,
  stopColor: "#A87CFB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.585,
  stopColor: "#149197"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.777,
  stopColor: "#13A038"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "h",
  x1: 13.09,
  x2: 13.09,
  y1: 3.333,
  y2: 32.855,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.313,
  stopColor: "#A87CFB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.585,
  stopColor: "#149197"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.777,
  stopColor: "#13A038"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "i",
  x1: 13.09,
  x2: 13.09,
  y1: 3.333,
  y2: 32.855,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.313,
  stopColor: "#A87CFB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.585,
  stopColor: "#149197"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.777,
  stopColor: "#13A038"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "j",
  x1: 13.09,
  x2: 13.09,
  y1: 3.333,
  y2: 32.855,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.313,
  stopColor: "#A87CFB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.585,
  stopColor: "#149197"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.777,
  stopColor: "#13A038"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "k",
  x1: 13.09,
  x2: 13.09,
  y1: 3.333,
  y2: 32.855,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.313,
  stopColor: "#A87CFB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.585,
  stopColor: "#149197"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.777,
  stopColor: "#13A038"
})));
const CopilotLightIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 41,
  height: 40,
  fill: "none"
}, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref0, _ref1, _ref10);
export default CopilotLightIcon;